export interface ITextbookAnchor {
  textbookId: string;
  filePath: string;
  anchorId: string;
  anchorLabel: string;
}

// Base interface with shared properties
export interface IDecisionFieldBase {
  name: string;
  fieldName: string;
  description: string;
  displayOrder: number;
  visible: number;
  textbookAnchors?: ITextbookAnchor[];
}

// Existing numeric field (default for backward compatibility)
export interface INumericDecisionField extends IDecisionFieldBase {
  fieldType?: 'numeric'; // optional for backward compat with existing data
  value: number;
  previousValue: number;
  precis: number;
  min: number;
  max: number;
  dropdown?: Record<string, number>;
}

// Quiz choice option
export interface IQuizChoice {
  key: string; // 'A', 'B', 'C', 'D'
  label: string; // The answer text
}

// New quiz field
export interface IQuizDecisionField extends IDecisionFieldBase {
  fieldType: 'quiz';
  question: string;
  choices: IQuizChoice[];
  selectedChoice: string | null; // 'A', 'B', 'C', 'D' or null
  rationale: string;
  rationaleMaxLength?: number; // defaults to 2000
}

// Union type for all field types
export type IDecisionField = INumericDecisionField | IQuizDecisionField;

// Type guard helpers
export function isQuizField(field: IDecisionField): field is IQuizDecisionField {
  return field.fieldType === 'quiz';
}

export function isNumericField(field: IDecisionField): field is INumericDecisionField {
  return !field.fieldType || field.fieldType === 'numeric';
}

export interface IDecisionModule {
  moduleName: string;
  description: string;
  isQuiz?: boolean;
  fields: IDecisionField[];
}

export interface IDecision {
  category: string;
  modules: IDecisionModule[];
}
